/* eslint-disable max-len */
import { DownloadOutlined } from '@ant-design/icons';
import { Col, Form, Row } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import { AxiosResponse } from 'axios';
import dayjs from 'dayjs';
import { sum } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { IAkcionar, IHlasovani } from 'types/akcionar';
import { IPrehledy } from 'types/spravceUctuType';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import Hlasovani from 'components/molecules/Akcionar/Hlasovani';
import HromadneHlasovaniTable from 'components/molecules/Akcionar/HromadneHlasovaniTable';
import FormWrapper from 'components/molecules/FormWrapper';
import { RowTitles } from 'components/molecules/RowTitles';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';
import useProfily from 'hooks/useProfily';

import akcionarApi from 'services/akcionar/akcionar';
import { hlasovaniAkcionarPost, hlasovaniAkcionarPut } from 'services/akcionar/hlasovaniAkcionar';
import stahnoutPdfApi from 'services/akcionar/stahnoutPdf';
import fileDownload from 'services/fileDownload';
import {
    IHlasovaniHromadne,
    IHlasovaniHromadneBody,
    IHromadneHlasovaniData,
    hromadneHlasovaniGET,
    hromadneHlasovaniZapsatPut
} from 'services/spravceUctu/hromadneHlasovani';
import { hlasovaniSpravceGet, hlasovaniSpravcePost, hlasovaniSpravcePut } from 'services/spravceUctu/spravceHlasovani';
import stahnoutPdfSpravce from 'services/spravceUctu/spravceStahnoutPdf';

import { EHlasovani } from 'enums/akcionarKorpAkce/hlasovani';
import { EStavHl } from 'enums/akcionarKorpAkce/stavHl';
import { splitUrl } from 'enums/regExp';
import routePathEnum from 'enums/routePathEnum';

interface IHlasovaniAkcionar {}
/**
 * TODO: Rozsekat na mensi casti at je to citelny
 */
const HlasovaniAkcionar: React.FC<IHlasovaniAkcionar> = () => {
    const { setLevel } = useProfily();
    const [form] = Form.useForm();
    const location = useLocation();
    const { navigateWorkaround } = useNavigateWorkaround();
    const { spravceSelectedCard } = useContext(Context);
    const [akcionar, setAkcionar] = useState<IAkcionar>();
    const splitURL = location.pathname.split(splitUrl)[0];
    // oid a id sa pouziva len pri spravcovi uctu (pouziva ine sluzby) ak je definove volaju sa sluzby pre spravcu
    const { oid, id, company } = useParams<{ oid: string; id: string; company: string }>();
    const [page, setPage] = useState<number>(window.location.href.includes('hromadne') ? 2 : 1);
    const [visible, setVisible] = useState<boolean>(false);
    const [activeModal, setActiveModal] = useState<number>(0);
    const [loadingDownload, setLoadingDownload] = useState<boolean>(false);
    const [allowToPut, setAllowToPut] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [bodyHlasovani, setBodyHlasovani] = useState<IHlasovani[]>([]);
    const [maxPocet, setmaxPocet] = useState<number>(0);
    const [submitedPocet, setSubmitedPocet] = useState<(number | undefined)[]>([]);
    const [showSucces, setShowSucces] = useState<boolean>(false);
    const [submiting, setSubmiting] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [confirmContinue, setConfirmContinue] = useState<boolean[]>();
    const [hlasovaniMaxPocetError, setHlasovaniMaxPocetError] = useState<boolean>();
    const isHromadneHlasovani = window.location.href.includes('hromadne');
    const [akcionarHromadne, setAkcionarHromadne] = useState<IHromadneHlasovaniData>();
    const [bodyHlasovaniHromadne, setBodyHlasovaniHromadne] = useState<IHlasovaniHromadneBody[]>([]);
    const [hlasovaniHromadnePUT, setHlasovaniHromadnePUT] = useState<IHlasovaniHromadne[]>([]);
    const [hromadneModalConfirm, setHromadneModalConfirm] = useState<boolean>(false);

    useEffect(() => {
        if (isHromadneHlasovani) {
            hromadneHlasovaniGET(id!).then(resp => {
                setBodyHlasovaniHromadne(resp.vh.bodyvh);
                setAkcionarHromadne(resp);
            });
        } else if (oid) {
            hlasovaniSpravceGet(id!, oid).then((resp: AxiosResponse<IAkcionar>) => {
                form.setFieldsValue({
                    maxPocet:
                        resp.data.hlasovani && resp.data.hlasovani.celkem ? resp.data.hlasovani.celkem : resp.data.pocet
                });
                resp.data.hlasovani && setBodyHlasovani(resp.data.hlasovani.sezhlasovani);
                setAkcionar(resp.data);
                setmaxPocet(
                    resp.data.hlasovani && resp.data.hlasovani.celkem ? resp.data.hlasovani.celkem : resp.data.pocet
                );
            });
        } else if (!isHromadneHlasovani) {
            akcionarApi(company!).then((resp: AxiosResponse<IAkcionar>) => {
                form.setFieldsValue({
                    maxPocet:
                        resp.data.hlasovani && resp.data.hlasovani.celkem ? resp.data.hlasovani.celkem : resp.data.pocet
                });
                resp.data.hlasovani && setBodyHlasovani(resp.data.hlasovani.sezhlasovani);
                setAkcionar(resp.data);
                setmaxPocet(
                    resp.data.hlasovani && resp.data.hlasovani.celkem ? resp.data.hlasovani.celkem : resp.data.pocet
                );
            });
        }
        return () => setLevel('srdHlasovani', null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (akcionar?.stavhl === EStavHl.HLASOVANO || dayjs().diff(dayjs(akcionar?.datumkonani), 'hours') > 0)
            setPage(3);
    }, [akcionar]);

    useEffect(() => {
        // validacia prebieha v Hlasovani. Nastavenie modal Okna
        if (submiting) {
            if (confirmContinue?.includes(true)) {
                setVisible(true);
                setSubmiting(false);
                return;
            }
            setSubmiting(false);
            setPage(pv => pv + 1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [confirmContinue]);

    useEffect(() => {
        // zapisanie hodnot ktore su pouzite pri validacii
        if (akcionar) {
            const labels = akcionar?.vh.bodyvh.map(e => e.issrlabl) || '';
            const arr = labels.map(e => {
                const value = bodyHlasovani.filter(a => a.issrlabl === e);
                const indexValue = value.length ? sum(value[0].sezhlasu.map(k => k.pocet)) : 0;
                return indexValue;
            });
            setConfirmContinue(Array(labels.length).fill(false));
            setSubmitedPocet(arr);
        }
        if (isHromadneHlasovani) {
            const labels = bodyHlasovaniHromadne?.map(e => e.issrlabl) || '';
            setConfirmContinue(Array(labels.length).fill(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bodyHlasovani, akcionar, bodyHlasovaniHromadne]);

    const hlasovaniPut = (pocetMax?: number) => {
        if (oid && !isHromadneHlasovani) {
            hlasovaniSpravcePut(id!, oid, {
                celkem: pocetMax || 0,
                sezhlasovani: bodyHlasovani.map(e => {
                    return {
                        ...e,
                        sezhlasu: e.sezhlasu.filter(o => o.typhlasu !== EHlasovani.NULL)
                    };
                })
            });
        } else {
            hlasovaniAkcionarPut(company!, {
                celkem: pocetMax || 0,
                sezhlasovani: bodyHlasovani.map(e => {
                    return {
                        ...e,
                        sezhlasu: e.sezhlasu.filter(o => o.typhlasu !== EHlasovani.NULL)
                    };
                })
            });
        }
    };

    useEffect(() => {
        if (allowToPut) {
            hlasovaniPut(maxPocet);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bodyHlasovani]);

    const downloadPdf = () => {
        setLoadingDownload(val => !val);
        if (oid) {
            stahnoutPdfSpravce(id!)
                .then(({ data }) => fileDownload(data.redirect))
                .finally(() => setLoadingDownload(val => !val));
        } else {
            stahnoutPdfApi(company!)
                .then(({ data }) => fileDownload(data.redirect))
                .finally(() => setLoadingDownload(val => !val));
        }
    };

    const updateBodyHlasovani = (body: IHlasovani | IHlasovaniHromadne) => {
        if (isHromadneHlasovani) {
            setHlasovaniHromadnePUT(pv => {
                return [
                    ...pv.filter(({ issrlabl }) => issrlabl !== body.issrlabl),
                    ...((body as IHlasovaniHromadne).typhlasu !== EHlasovani.NULL ? [body as IHlasovaniHromadne] : [])
                ];
            });
        } else {
            setBodyHlasovani(pv => {
                return [...pv.filter(({ issrlabl }) => issrlabl !== body.issrlabl), body as IHlasovani];
            });
        }
    };

    return (
        <LoadingWrapper
            loading={!akcionar && !akcionarHromadne}
            style={{
                width: '100%'
            }}
        >
            {(akcionar || akcionarHromadne) && (
                <>
                    <Row>
                        <Col span={6}>
                            <Title level={2} text="SRD_PRUVODCE_VH_E_PRIDAT_VOTETP" />
                        </Col>
                    </Row>
                    {[1, 3].includes(page) && (
                        <>
                            <Title level={3} text="PREHLED" />
                            <Title level={5} text="SRD_PRUVODCE_VH_A" dividerTitle={true} />
                            <RowTitles
                                style={{
                                    position: 'relative',
                                    top: '-8px',
                                    maxWidth: '780px',
                                    paddingBottom: '10px'
                                }}
                                paragraph={true}
                                firstText={'SRD_PRUVODCE_VH_B_ID'}
                                secondText={akcionar?.vh.reqid.toString() || ''}
                            />
                            <Title level={5} text="SRD_PRUVODCE_VH_B" dividerTitle={true} />
                            <RowTitles
                                style={{
                                    position: 'relative',
                                    top: '-8px',
                                    maxWidth: '780px',
                                    paddingBottom: '10px'
                                }}
                                paragraph={true}
                                firstText="ISIN"
                                secondText={akcionar?.isin || ''}
                            />
                            <Title level={5} text="UDAJE_O_EMITENTOVI" dividerTitle={true} />
                            <RowTitles
                                style={{
                                    position: 'relative',
                                    top: '-8px',
                                    maxWidth: '780px',
                                    paddingBottom: '10px'
                                }}
                                paragraph={true}
                                firstText="ZAKLADNI_UDAJE"
                                secondText={akcionar?.vh.emitent || ''}
                            />
                            <Title level={5} text="SRD_PRUVODCE_VH_C" dividerTitle={true} />
                            <ButtonComponent
                                id="akcionarHlasovaniStahnoutPDFbtn"
                                buttontext="STAHNOUT_PDF"
                                className="akcionar-card-button"
                                onClick={downloadPdf}
                                loading={loadingDownload}
                                icon={<DownloadOutlined />}
                            />
                            <Title level={5} text="SRD_PRUVODCE_VH_D" dividerTitle={true} />
                            <RowTitles
                                style={{
                                    position: 'relative',
                                    top: '-8px',
                                    maxWidth: '780px',
                                    paddingBottom: '10px'
                                }}
                                paragraph={true}
                                firstText="SRD_PRUVODCE_VYPIS_MEZNIDATUM"
                                secondText={dayjs(akcionar?.vh.termin).format('DD.MM.YYYY') || ''}
                            />
                        </>
                    )}
                    {[2, 3].includes(page) && (
                        <>
                            {' '}
                            {page === 2 && !isHromadneHlasovani && (
                                <>
                                    <Title level={4} text="SRD_PRUVODCE_VH_E" />
                                    <FormWrapper
                                        onFinish={values => {
                                            setmaxPocet(values.maxPocet);
                                            hlasovaniPut(values.maxPocet);
                                        }}
                                        outForm={form}
                                    >
                                        <Row>
                                            <Col>
                                                <Paragraph
                                                    style={{
                                                        fontWeight: 600,
                                                        fontSize: 17
                                                    }}
                                                    text="AKCIONAR_HLASOVANI_MAXPOCET"
                                                />
                                                <Paragraph
                                                    style={{
                                                        fontWeight: 600,
                                                        fontSize: 17
                                                    }}
                                                    text={` (max: ${akcionar?.pocet || ''})`}
                                                />
                                            </Col>
                                            <Col offset={1} span={6}>
                                                <InputComponent
                                                    name="maxPocet"
                                                    maxLength={10}
                                                    initialValue={maxPocet}
                                                    rules={[
                                                        {
                                                            validator(_rule, value: number) {
                                                                try {
                                                                    if (value < 1 || value > (akcionar?.pocet || 0))
                                                                        return Promise.reject(
                                                                            <TranslateText
                                                                                params={[akcionar?.pocet || '']}
                                                                            >
                                                                                AKCIONAR_MAXPOCET_ZMENA_ERR
                                                                            </TranslateText>
                                                                        );
                                                                    if (!isNaN(value)) return Promise.resolve();
                                                                    return Promise.reject(
                                                                        <TranslateText>NEVALIDNI_NUM</TranslateText>
                                                                    );
                                                                } catch {
                                                                    return Promise.reject();
                                                                }
                                                            }
                                                        }
                                                    ]}
                                                    notRequired={true}
                                                />
                                            </Col>
                                            <Col offset={1} span={6}>
                                                <ButtonComponent
                                                    onClick={() => form.submit()}
                                                    buttontext="ZMENIT"
                                                    id="akcionarHlasovaniZmenitbtn"
                                                />
                                            </Col>
                                        </Row>
                                    </FormWrapper>
                                </>
                            )}
                            {isHromadneHlasovani ? (
                                <HromadneHlasovaniTable
                                    IDhlasovani={id!}
                                    page={page}
                                    updateHlasovani={updateBodyHlasovani}
                                    bodyHlasovani={bodyHlasovaniHromadne}
                                    zapsaneHlasy={hlasovaniHromadnePUT}
                                    setConfirmContinue={setConfirmContinue}
                                    submiting={submiting}
                                    setAllowToPut={setAllowToPut}
                                    setVisible={setVisible}
                                    setActiveModal={setActiveModal}
                                    akcionar={akcionarHromadne!}
                                />
                            ) : (
                                akcionar?.vh.bodyvh.map((body, index) => (
                                    <div key={index + body.issrlabl}>
                                        <Row
                                            style={
                                                body.forinfonly && {
                                                    marginBottom: '24px'
                                                }
                                            }
                                        >
                                            <AnchorComponent
                                                link={true}
                                                key={index}
                                                onClick={() => {
                                                    setConfirmContinue(pv => pv?.map(() => false));
                                                    setVisible(val => !val);
                                                    setActiveModal(index);
                                                }}
                                            >
                                                {body.issrlabl + ' ' + body.titl}
                                            </AnchorComponent>
                                        </Row>
                                        {!body.forinfonly && (
                                            <Hlasovani
                                                body={body}
                                                page={page}
                                                updateHlasovani={updateBodyHlasovani}
                                                bodyHlasovani={
                                                    bodyHlasovani.filter(
                                                        e => e.issrlabl === akcionar?.vh.bodyvh[index].issrlabl
                                                    )[0] || []
                                                }
                                                maxPocet={maxPocet}
                                                indexBody={index}
                                                setConfirmContinue={setConfirmContinue}
                                                submitedPocet={submitedPocet[index]}
                                                submiting={submiting}
                                                setAllowToPut={setAllowToPut}
                                            />
                                        )}
                                    </div>
                                ))
                            )}
                            <Modal
                                title={<TranslateText>SRD_PRUVODCE_VH_E_PRIDAT_INF</TranslateText>}
                                open={visible || hromadneModalConfirm}
                                onCancel={() => {
                                    setVisible(false);
                                    setHromadneModalConfirm(false);
                                }}
                                footer={null}
                            >
                                {!confirmContinue?.includes(true) && !hromadneModalConfirm ? (
                                    <>
                                        <Row
                                            style={{
                                                alignItems: 'flex-end'
                                            }}
                                        >
                                            <Col span={12}>
                                                <b>
                                                    <Paragraph text={'SRD_PRUVODCE_VH_E_PRIDAT_ISSSRLABL'} />:
                                                </b>
                                            </Col>
                                            <Paragraph
                                                text={
                                                    akcionar?.vh.bodyvh[activeModal].issrlabl ||
                                                    bodyHlasovaniHromadne[activeModal].issrlabl
                                                }
                                            />
                                        </Row>
                                        <Row
                                            style={{
                                                alignItems: 'flex-end'
                                            }}
                                        >
                                            <Col span={12}>
                                                <b>
                                                    <Paragraph text={'SRD_PRUVODCE_VH_E_PRIDAT_TITL'} />:
                                                </b>
                                            </Col>
                                            <Paragraph
                                                text={` 
                                                ${
                                                    akcionar?.vh.bodyvh[activeModal].titl ||
                                                    bodyHlasovaniHromadne[activeModal].titl
                                                }`}
                                            />
                                        </Row>
                                        <Row
                                            style={{
                                                alignItems: 'flex-end'
                                            }}
                                        >
                                            <Col span={12}>
                                                <b>
                                                    <Paragraph text={'POPIS'} />:
                                                </b>
                                            </Col>
                                            <Paragraph
                                                text={`${
                                                    akcionar?.vh.bodyvh[activeModal].desc ||
                                                    bodyHlasovaniHromadne[activeModal].desc
                                                }`}
                                            />
                                        </Row>
                                        {akcionar?.vh.bodyvh[activeModal].URLAddress && (
                                            <Row
                                                style={{
                                                    alignItems: 'flex-end'
                                                }}
                                            >
                                                <RouterLink
                                                    to={
                                                        akcionar?.vh.bodyvh[activeModal].URLAddress ||
                                                        bodyHlasovaniHromadne[activeModal].urladdress
                                                    }
                                                />
                                            </Row>
                                        )}
                                        <Row
                                            style={{
                                                alignItems: 'flex-end'
                                            }}
                                        >
                                            <>
                                                <Col span={12}>
                                                    <b>
                                                        <Paragraph text={'SRD_PRUVODCE_VH_E_PRIDAT_FORINFOONLY'} />:
                                                    </b>
                                                </Col>
                                                <TranslateText>
                                                    {!!akcionar?.vh.bodyvh[activeModal].forinfonly ||
                                                    !!(
                                                        bodyHlasovaniHromadne[activeModal] &&
                                                        bodyHlasovaniHromadne[activeModal].forinfonly
                                                    )
                                                        ? 'ANO'
                                                        : 'NE'}
                                                </TranslateText>
                                            </>
                                        </Row>
                                        <Row
                                            style={{
                                                alignItems: 'flex-end'
                                            }}
                                        >
                                            <>
                                                <Col span={12}>
                                                    <b>
                                                        <Paragraph text={'SRD_PRUVODCE_VH_E_PRIDAT_VOTETP'} />:
                                                    </b>
                                                </Col>
                                                <TranslateText>
                                                    {akcionar?.vh.bodyvh[activeModal].votetp ||
                                                        bodyHlasovaniHromadne[activeModal].votetp}
                                                </TranslateText>
                                            </>
                                        </Row>
                                        <Row>
                                            <Col span={10}>
                                                <b>
                                                    <Paragraph text={'SRD_PRUVODCE_VH_E_PRIDAT_VOTETP_OPTIONS'} />:
                                                </b>
                                            </Col>
                                            <Col span={14}>
                                                <ul>
                                                    {(
                                                        (isHromadneHlasovani
                                                            ? bodyHlasovaniHromadne[activeModal].hlasovani
                                                            : akcionar?.vh.bodyvh[activeModal].hlasovani) || []
                                                    ).map(({ hlasovani }, i) => (
                                                        <li key={i}>
                                                            <TranslateText>{hlasovani}</TranslateText>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </Col>
                                        </Row>
                                    </>
                                ) : (
                                    <>
                                        <Row
                                            style={{
                                                paddingTop: 10
                                            }}
                                        >
                                            <Paragraph text={'SRD_PRUVODCE_VH_E_PRIDAT_NOSUBMIT'} />
                                        </Row>
                                        <Row
                                            style={{
                                                marginTop: 40,
                                                position: 'relative',
                                                bottom: 0
                                            }}
                                        >
                                            <ButtonComponent
                                                style={{
                                                    marginRight: 20
                                                }}
                                                buttontext="ANO"
                                                id="hlasovaniAkcionarModalAnoBtn"
                                                onClick={() => {
                                                    setHromadneModalConfirm(false);
                                                    setVisible(false);
                                                    setPage(pv => pv + 1);
                                                }}
                                            />
                                            <ButtonComponent
                                                id="hlasovaniAkcionarModalNeBtn"
                                                buttontext="NE"
                                                onClick={() => {
                                                    setHromadneModalConfirm(false);
                                                    setVisible(false);
                                                }}
                                            />
                                        </Row>
                                    </>
                                )}
                            </Modal>
                        </>
                    )}
                    <Row>
                        {(typeof oid === 'string' || page !== 1) && (
                            <>
                                {page === 1 && (
                                    <ButtonComponent
                                        buttontext="ZPET"
                                        id="akcionarHlasovaniZpetPBtn"
                                        type="default"
                                        onClick={() => navigateWorkaround(-1)}
                                        style={{
                                            marginRight: 10
                                        }}
                                    />
                                )}
                                {page === 3 && oid && (
                                    <ButtonComponent
                                        buttontext="ZPET"
                                        id="akcionarHlasovaniZpetP3Btn"
                                        type="default"
                                        onClick={() =>
                                            navigateWorkaround(
                                                `/${location.pathname.split('/').slice(1, 3).join('/')}${
                                                    spravceSelectedCard?.isUcastnik
                                                        ? routePathEnum.PREHLED_UCASTNIK_HLASOVANI
                                                        : routePathEnum.PREHLED_SPRAVCE
                                                }`
                                            )
                                        }
                                        style={{
                                            marginRight: 10
                                        }}
                                    />
                                )}
                                {(page !== 3 || (akcionar?.stavhl === 'HLASOVANO' && !oid)) && page !== 1 && (
                                    <ButtonComponent
                                        id="akcionarHlasovaniZpetbtn"
                                        buttontext="ZPET"
                                        type="default"
                                        onClick={() => {
                                            if (spravceSelectedCard)
                                                navigateWorkaround(
                                                    `/${location.pathname.split('/').slice(1, 3).join('/')}${
                                                        spravceSelectedCard?.isUcastnik
                                                            ? routePathEnum.PREHLED_UCASTNIK_HLASOVANI
                                                            : routePathEnum.PREHLED_SPRAVCE
                                                    }`
                                                );
                                            akcionar?.stavhl === 'HLASOVANO' &&
                                                !isEdit &&
                                                navigateWorkaround(`${splitURL}${routePathEnum.PREHLED_AKCIONAR}`);
                                            setPage(pv => pv - 1);
                                        }}
                                        style={{
                                            marginRight: 10
                                        }}
                                    />
                                )}
                                {page === 3 && (akcionar?.stavhl !== 'HLASOVANO' || (isEdit && oid)) && (
                                    <ButtonComponent
                                        id="akcionarHlasovaniUpravitbtn"
                                        buttontext={'UPRAVIT_HLASOVANI'}
                                        type={'primary'}
                                        onClick={() => {
                                            setPage(pv => pv - 1);
                                            oid && setIsEdit(true);
                                        }}
                                        style={{
                                            marginRight: 10
                                        }}
                                    />
                                )}
                                {/* !oid && akcionar?.stavhl !== 'HLASOVANO' &&  || ''(
                                        <ButtonComponent
                                            buttontext={
                                                page === 3 && (akcionar?.stavhl !== 'HLASOVANO' || oid || '')
                                                    ? 'UPRAVIT_HLASOVANI'
                                                    : 'ZPET'
                                            }
                                            type={
                                                page === 3 && (akcionar?.stavhl !== 'HLASOVANO' || oid || '')
                                                    ? 'primary'
                                                    : 'default'
                                            }
                                            onClick={
                                                page === 3 && akcionar?.stavhl === 'HLASOVANO' && !isEdit && !oi || ''d
                                                    ? () => navigateWorkaround(`${splitURL}${routePathEnum.PREHLED_AKCIONAR}`)
                                                    : () => setPage(pv => pv - 1)
                                            }
                                            style={{
                                                marginRight: 10
                                            }}
                                        />
                                        )*/}
                            </>
                        )}
                        {(spravceSelectedCard ? dayjs(spravceSelectedCard.eltermin) >= dayjs() : true) &&
                            page !== 3 && (
                                <ButtonComponent
                                    buttontext="POKRACOVAT"
                                    id="akcionarHlasovaniPokracovatBtn"
                                    onClick={() => {
                                        if (page === 2) {
                                            if (isHromadneHlasovani) {
                                                if (
                                                    bodyHlasovaniHromadne.filter(e => !e.forinfonly).length !==
                                                    hlasovaniHromadnePUT.length
                                                ) {
                                                    setHromadneModalConfirm(true);
                                                    return;
                                                }
                                            } else {
                                                if (!submitedPocet.some(e => e && e > maxPocet)) {
                                                    setHlasovaniMaxPocetError(false);
                                                    setSubmiting(true);
                                                } else {
                                                    setHlasovaniMaxPocetError(true);
                                                }
                                                return;
                                            }
                                        }
                                        setPage(pv => pv + 1);
                                    }}
                                    extramessage={hlasovaniMaxPocetError ? 'AKCIONAR_MAXPOCET_SUBMIT_ERR' : ''}
                                />
                            )}
                        {page === 3 &&
                            (isHromadneHlasovani
                                ? dayjs().diff(dayjs(akcionarHromadne?.vh.termin), 'hours') < 0 &&
                                  dayjs().diff(dayjs(akcionarHromadne?.rozhodnyden), 'hours') > 0
                                : dayjs().diff(dayjs(akcionar?.vh.termin), 'hours') < 0 &&
                                  dayjs().diff(dayjs(akcionar?.rozhodnyden), 'hours') > 0) &&
                            (akcionar?.stavhl !== EStavHl.HLASOVANO || isEdit || isHromadneHlasovani ? (
                                <>
                                    <ButtonComponent
                                        id="akcionarHlasovaniHlasovatBtn"
                                        buttontext="HLASOVAT"
                                        onClick={() => {
                                            setLoading(true);
                                            if (isHromadneHlasovani) {
                                                hromadneHlasovaniZapsatPut(id!, {
                                                    sezhlasovani: hlasovaniHromadnePUT.filter(
                                                        o => o.typhlasu !== EHlasovani.NULL
                                                    )
                                                }).finally(() => {
                                                    setLoading(false);
                                                    setShowSucces(true);
                                                });
                                            } else if (oid) {
                                                hlasovaniSpravcePost(id!, oid, {
                                                    celkem: maxPocet,
                                                    sezhlasovani: bodyHlasovani.map(e => {
                                                        return {
                                                            ...e,
                                                            sezhlasu: e.sezhlasu.filter(
                                                                o => o.typhlasu !== EHlasovani.NULL
                                                            )
                                                        };
                                                    })
                                                }).finally(() => {
                                                    setLoading(false);
                                                    setShowSucces(true);
                                                });
                                            } else {
                                                hlasovaniAkcionarPost(company!, {
                                                    celkem: maxPocet,
                                                    sezhlasovani: bodyHlasovani.map(e => {
                                                        return {
                                                            ...e,
                                                            sezhlasu: e.sezhlasu.filter(
                                                                o => o.typhlasu !== EHlasovani.NULL
                                                            )
                                                        };
                                                    })
                                                }).finally(() => {
                                                    setLoading(false);
                                                    setShowSucces(true);
                                                });
                                            }
                                        }}
                                        loading={loading}
                                    />
                                </>
                            ) : (
                                <ButtonComponent
                                    buttontext="UPRAVIT_HLASOVANI"
                                    id="akcionarHlasovaniUpravitAltBtn"
                                    onClick={() => {
                                        setPage(pv => pv - 1);
                                        setIsEdit(true);
                                    }}
                                    loading={loading}
                                />
                            ))}
                    </Row>
                    <Modal
                        title={<TranslateText>SRD_PRUVODCE_VH_E_PRIDAT_VOTETP</TranslateText>}
                        open={showSucces}
                        onCancel={() => {
                            if (spravceSelectedCard) {
                                const spravceSelectedNew = {
                                    ...spravceSelectedCard
                                };
                                delete spravceSelectedNew.hromadneHlasovaniID;
                                setLevel('spravceSelectedCard', spravceSelectedNew as IPrehledy);
                                navigateWorkaround(
                                    `/${location.pathname.split('/').slice(1, 3).join('/')}${
                                        spravceSelectedCard?.isUcastnik
                                            ? routePathEnum.PREHLED_UCASTNIK_HLASOVANI
                                            : routePathEnum.PREHLED_SPRAVCE
                                    }`
                                );
                            }
                            setShowSucces(val => !val);
                            navigateWorkaround(`${splitURL}${routePathEnum.PREHLED_AKCIONAR}`);
                        }}
                        footer={[
                            <Row>
                                <ButtonComponent
                                    id="akcionarHlasovaniSubmitBtn"
                                    buttontext="POKRACOVAT"
                                    onClick={() => {
                                        if (spravceSelectedCard) {
                                            const spravceSelectedNew = {
                                                ...spravceSelectedCard
                                            };
                                            delete spravceSelectedNew.hromadneHlasovaniID;
                                            setLevel('spravceSelectedCard', spravceSelectedNew as IPrehledy);
                                            navigateWorkaround(
                                                `/${location.pathname.split('/').slice(1, 3).join('/')}${
                                                    spravceSelectedCard?.isUcastnik
                                                        ? routePathEnum.PREHLED_UCASTNIK_HLASOVANI
                                                        : routePathEnum.PREHLED_SPRAVCE
                                                }`
                                            );
                                        } else {
                                            navigateWorkaround(`${splitURL}${routePathEnum.PREHLED_AKCIONAR}`);
                                        }
                                    }}
                                />
                            </Row>
                        ]}
                    >
                        <Row>
                            <Paragraph text="SRD_PRUVODCE_VH_E_SUCCESS" />
                        </Row>
                    </Modal>
                </>
            )}
        </LoadingWrapper>
    );
};

export default HlasovaniAkcionar;
